<template>
  <div class="container">
    <div class="outer-bar">
      <p class="inner-bar" :style="widthValue">
        <span class="cut">
          {{ scoreValue }}
        </span>
      </p>
    </div>
    <div class="bottom-scale">
      <span class="scale" v-for="scale in scaleArr" :key="scale">
        {{ scale }}
      </span>
    </div>
    <div class="infoBox" v-if="infoArr.length">
      <p v-for="(item, index) in infoArr" :key="index">
        <span class="infoTitle">{{ item.title }}:</span>
        <span class="infoValue">{{ item.value }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'process-bar',
  data() {
    return {}
  },
  computed: {
    widthValue: function () {
      return `width: ${(this.scoreValue / this.total) * 100}%`
    },
  },
  props: {
    scoreValue: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 10,
    },
    scaleArr: {
      type: Array,
      default: () => [],
    },
    infoArr: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped lang="less">
.container {
  .outer-bar {
    width: 100%;
    height: 16px;
    background-image: linear-gradient(
      269deg,
      #00ca42 1%,
      #ffdc00 71%,
      #d00000 100%
    );
    border-radius: 16px;
    display: flex;
    .inner-bar {
      height: 16px;
      display: flex;
      justify-content: flex-end;
      padding-left: 8px;
      .cut {
        position: relative;
        display: inline-block;
        height: 100%;
        line-height: 16px;
        font-size: 12px;
        color: #000000;
        font-weight: 400;
        &::after {
          content: '';
          width: 0;
          height: 0;
          border-bottom: solid 3px #f5f5fa;
          border-left: solid 3px transparent;
          border-right: solid 3px transparent;
          position: absolute;
          bottom: 0;
          left: 50%;
        }
      }
    }
  }
  .bottom-scale {
    display: flex;
    justify-content: space-between;
    .scale {
      position: relative;
      font-size: 12px;
      color: #3a3f63;
      letter-spacing: 0;
      margin-top: 12px;
      &::after {
        content: '';
        display: inline-block;
        width: 1px;
        height: 6px;
        //background: #e3e7f2;
        background-color: #e3e7f2;
        position: absolute;
        bottom: 15px;
        left: 50%;
      }
    }
  }
  .infoBox {
    display: flex;
    flex-direction: column;
    margin-top: 26px;
    p {
      display: flex;
      margin-bottom: 12px;
      .infoTitle {
        font-size: 14px;
        color: #2b2f42;
        letter-spacing: 0;
        text-align: right;
        font-weight: 700;
      }
      .infoValue {
        font-size: 14px;
        color: #3a3f63;
        letter-spacing: 0;
        font-weight: 400;
        margin-left: 8px;
      }
    }
  }
}
</style>
